/** The AI clients we have a mark of our own for. */
export type KnownApp =
  | "claude"
  | "cursor"
  | "gemini-cli"
  | "codex"
  | "webshare-cli";

/** Claude's brand colour, the same in light and dark mode. */
export const CLAUDE_BRAND_COLOR = "#D97757";

/**
 * Which of our own marks an application gets, matched on the name it
 * registered with. Clients name themselves, so this only recognises a name;
 * nothing a client supplied (an icon, a logo URL) is ever drawn. A name we do
 * not know gets `undefined`, and the caller's generic mark.
 */
export function matchKnownApp(name: string): KnownApp | undefined {
  const normalized = name.trim().toLowerCase();
  if (normalized.includes("claude")) return "claude";
  if (normalized.includes("cursor")) return "cursor";
  if (normalized.includes("gemini")) return "gemini-cli";
  if (normalized.includes("codex")) return "codex";
  if (normalized === "webshare cli") return "webshare-cli";
  return undefined;
}
